import { ElTooltip as h } from "element-plus";
import { resolveComponent as m, openBlock as i, createElementBlock as a, Fragment as T, createCommentVNode as g, createVNode as N, mergeProps as w, createSlots as y, withCtx as d, createElementVNode as c, renderSlot as f, normalizeClass as _, toDisplayString as b } from "vue";
import { _ as I } from "../_plugin-vue_export-helper-dad06003.js";
const v = {
  name: "rTooltip",
  components: {
    Tooltip: h
  },
  props: {
    /**
     * 占位值
     */
    placeholder: {
      type: String
    },
    /**
     * 占位值是否加下划线
     */
    underline: {
      type: Boolean,
      default: !0
    },
    /**
     * 同el-tooltip组件的popperClass
     */
    popperClass: {
      type: String
    },
    /**
     * 子元素超出才显示 tip
     */
    showIfNeed: {
      type: Boolean,
      default: !1
    }
  },
  data() {
    return {
      showTipIfNeed: !0
    };
  },
  computed: {},
  mounted() {
    this.$nextTick(() => {
      this.observeDom(), this.judgeIfNeed();
    });
  },
  methods: {
    observeDom() {
      const e = this.$refs.rToolTipPlaceholder, s = new MutationObserver((l, n) => {
        for (const o of l)
          o.type === "childList" || o.type, this.judgeIfNeed();
      }), t = {
        childList: !0,
        // 观察子节点的变化
        attributes: !0,
        // 观察属性变化
        subtree: !0
        // 观察所有后代节点
      };
      s.observe(e, t);
    },
    judgeIfNeed() {
      let e = this.$refs.rToolTipPlaceholder;
      if (!e)
        return;
      const s = e.parentNode, { clientWidth: t, offsetWidth: l } = e, n = window.getComputedStyle(s), {
        width: o,
        "padding-left": r,
        "padding-right": u
      } = n;
      l >= parseFloat(o) - parseFloat(r) - parseFloat(u) - 2 ? this.showTipIfNeed = !0 : this.showTipIfNeed = !1;
    }
  }
}, k = { ref: "rToolTipPlaceholder" }, $ = { key: 0 }, C = { class: "content" };
function S(e, s, t, l, n, o) {
  const r = m("Tooltip", !0);
  return i(), a(
    T,
    null,
    [
      g(` :style="showIfNeed ? 'display: block!important' : ' '" `),
      N(r, w(e.$attrs, {
        ref: "rToolTip",
        class: {
          "r-tooltip": !0,
          "r-tooltip-full-width": t.showIfNeed
        },
        disabled: t.showIfNeed && !n.showTipIfNeed,
        "popper-class": `r-tooltip-tip ${t.popperClass}`,
        placement: e.$attrs.placement || "top-start"
      }), y({
        default: d(() => [
          c(
            "span",
            k,
            [
              e.$slots.default ? (i(), a("span", $, [
                f(e.$slots, "default")
              ])) : (i(), a(
                "span",
                {
                  key: 1,
                  class: _([
                    "r-tooltip-placeholder",
                    t.underline ? "r-tooltip-underline" : ""
                  ])
                },
                b(t.placeholder),
                3
                /* TEXT, CLASS */
              ))
            ],
            512
            /* NEED_PATCH */
          )
        ]),
        _: 2
        /* DYNAMIC */
      }, [
        e.$slots.content ? {
          name: "content",
          fn: d(() => [
            c("span", C, [
              f(e.$slots, "content")
            ])
          ]),
          key: "0"
        } : void 0
      ]), 1040, ["class", "disabled", "popper-class", "placement"])
    ],
    2112
    /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */
  );
}
const p = /* @__PURE__ */ I(v, [["render", S], ["__file", "/Users/dave/Documents/dev/bmui3/src/packages/tooltip/tooltip.vue"]]);
p.install = function(e) {
  e.component(p.name, p);
};
export {
  p as default
};
